export default __webpack_public_path__ + "static/media/logo-livros.e128deed.png";